import script from "./Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Header.vue?vue&type=script&setup=true&lang=js"

import "./Header.vue?vue&type=style&index=0&id=676bbbd0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-676bbbd0"]])

export default __exports__